import { render } from "./GeneralView.vue?vue&type=template&id=40e10c1a&scoped=true&ts=true"
import script from "./GeneralView.vue?vue&type=script&lang=ts"
export * from "./GeneralView.vue?vue&type=script&lang=ts"

import "./GeneralView.vue?vue&type=style&index=0&id=40e10c1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e10c1a"]])

export default __exports__